module.exports = __webpack_public_path__ + "img/SEARCH.ca7badff.svg";